// extracted by mini-css-extract-plugin
export var base = "_4o-0";
export var updateBanner = "_4o-1";